<div id="ht">
    <div id="main-cnt">
        <ion-header class="main-header block">
            <ion-toolbar class="blues-nav">
                <ion-buttons slot="start" class="nav-content">
                    <div size="2" class="nav-back">
            <span class="custom-icon-back-arrow-icon" (click)="back()">
              <span class="path1"></span>
              <span class="path2"></span>
            </span>
                        <ion-icon class="ion-padding-start" size="large" name="home"
                                  (click)="sessionService.gotoHome()"></ion-icon>
                        <span class="breadcrumb" *ngIf="profile === 'personal'"
                        >UTENTI - {{ currentUser?.lastname  |titlecase}} - {{ currentUser?.name  |titlecase|titlecase}}  - {{
                            currentUser?.role }}</span
                        >
                        <span class="breadcrumb" *ngIf="profile === 'education'"
                        >{{ currentUser?.name |titlecase }} {{ currentUser?.lastname  |titlecase}} - {{
                            currentUser?.role }} - CONTRATTI</span
                        >
                        <span class="breadcrumb" *ngIf="profile === 'clients'"
                        >ELENCO CLIENTI</span
                        >
                        <span class="breadcrumb" *ngIf="profile === 'summary'">REPORT</span>
                    </div>
                </ion-buttons>
                <div slot="end" class="notification-div">
                    <ion-avatar class="menu-user-icon" (click)="openPage('/my-profile')">
                        <img [src]="sessionService.user?.profileImg|s3Link">
                    </ion-avatar>
                </div>
            </ion-toolbar>
            <br/>

            <!-- edit da qui... -->
            <ion-avatar class="header-avatar">
                <img *ngIf="!currentUser?.profileImg" class="space-below svg-white" src="./assets/imgs/avatar.svg"/>
                <img *ngIf="currentUser?.profileImg" [src]="currentUser?.profileImg|s3Link">
                <span class="custom-icon-edit-icon" (click)="edit()"></span>
            </ion-avatar>

            <div class="glass-blurred-background panel-buttons-container">
                <div
                        class="panel-button theme-text-color"
                        [class.active]="currentPanel == 'elenco'"
                        (click)="currentPanel = 'elenco'"
                >
                    <div class="panel-button-image-container">
                        <img
                                class="panel-button-image svg-white"
                                src="./assets/imgs/elenco.svg"
                        />
                    </div>
                    <h4>Info</h4>
                </div>
                <div
                        class="panel-button theme-text-color"
                        [class.active]="currentPanel == 'clienti'"
                        (click)="currentPanel = 'clienti'"
                        *ngIf="currentUser?.permessions !== permessionTypes.CLIENT"
                >
                    <div class="panel-button-image-container">
                        <img
                                class="panel-button-image svg-white"
                                src="./assets/imgs/clienti.svg"
                        />
                    </div>
                    <h4>Clienti</h4>
                </div>
                <div
                        class="panel-button theme-text-color"
                        [class.active]="currentPanel == 'contratti'"
                        (click)="currentPanel = 'contratti'"
                >
                    <div class="panel-button-image-container">
                        <img
                                class="panel-button-image svg-white"
                                src="./assets/imgs/contratti.svg"
                        />
                    </div>
                    <h4>Contratti</h4>
                </div>
                <div
                        class="panel-button theme-text-color"
                        [class.active]="currentPanel == 'bonuses'"
                        (click)="currentPanel = 'bonuses'"
                        *ngIf="currentUser?.permessions !== permessionTypes.CLIENT"
                >
                    <div class="panel-button-image-container">
                        <img
                                class="panel-button-image svg-white"
                                src="./assets/imgs/bonus.svg"
                        />
                    </div>
                    <h4>Bonus</h4>
                </div>
            </div>

            <h3 class="panel-title" *ngIf="currentPanel == 'clienti'">Clienti</h3>
            <h3 class="panel-title" *ngIf="currentPanel == 'bonus'">Bonuses</h3>
            <h3 class="panel-title" *ngIf="currentPanel == 'contratti'">Contracts</h3>
            <!-- ...a qui -->
        </ion-header>

        <ion-content class="main-content" >
            <div class="scroller-container">
                <div class="content-scroller">
                    <div class="content" *ngIf="currentUser">
                        <!-- edit da qui... -->

                        <div class="flex-panel" *ngIf="currentPanel == 'elenco'">
                            <h3 class="section-title">Personal Info</h3>

                            <div class="glass-blurred-background full-width">
                                <div class="flex-row info">
                                    <span class="label">Name:</span>
                                    <span class="detail">{{ currentUser?.name |titlecase }}</span>
                                </div>
                                <div class="flex-row info">
                                    <span class="label">Last name:</span>
                                    <span class="detail">{{ currentUser?.lastname  |titlecase}}</span>
                                </div>
                                <div class="flex-row info">
                                    <span class="label">Employee ID:</span>
                                    <span class="detail"
                                    >{{ currentUser?.id.slice(0, 4) }}...</span
                                    >
                                    <div
                                            class="doc-icon copy"
                                            (click)="copy(currentUser.id)"
                                    ></div>
                                </div>
                                <div class="flex-row info">
                                    <span class="label">Phone:</span>
                                    <span class="detail">{{ currentUser?.phoneNumber }}</span>
                                    <div
                                            class="doc-icon copy"
                                            (click)="copy(currentUser.phoneNumber)"
                                    ></div>
                                </div>
                                <div class="flex-row info">
                                    <span class="label">Email:</span>
                                    <span class="detail">{{ currentUser?.email }}</span>
                                    <div
                                            class="doc-icon copy"
                                            (click)="copy(currentUser.email)"
                                    ></div>
                                </div>
                                <div class="flex-row info">
                                    <span class="label">Codice Fiscale:</span>
                                    <span class="detail">{{ currentUser?.cf }}</span>
                                    <div
                                            class="doc-icon copy"
                                            (click)="copy(currentUser.cf)"
                                    ></div>
                                </div>
                                <div class="flex-row info">
                                    <span class="label">Numero C.I:</span>
                                    <span class="detail">{{ currentUser?.numeroCI }}</span>
                                    <div
                                            class="doc-icon copy"
                                            (click)="copy(currentUser.numeroCI)"
                                    ></div>
                                </div>
                                <div class="flex-row info">
                                    <span class="label">Referente:</span>
                                    <span class="detail">{{ addedByFullName }}</span>
                                </div>

                                <div class="flex-row info">
                                    <span class="label">Note:</span>
                                    <span class="detail">{{ currentUser?.notes }}</span>
                                </div>
                                <div
                                        class="flex-row info"
                                        *ngIf="currentUser?.role !== 'CLIENT'"
                                >
                                    <span class="label">Wallet TRC20:</span>
                                    <span class="detail">{{currentUser?.TRC20}}</span>
                                    <div
                                            class="doc-icon copy"
                                            (click)="copy(currentUser.TRC20)"
                                    ></div>
                                </div>
                                <div class="flex-row info">
                  <span class="small"
                  ><i>confermo correttezza indirizzo TRC20</i></span
                  >
                                    <input
                                            class="doc-icon copy"
                                            type="checkbox"
                                            [checked]="currentUser?.TRC20Active"
                                            (change)="toggleTRC20($event)"
                                    />
                                </div>
                            </div>

                            <br/>
                            <h3 class="section-title">Upload files</h3>

                            <app-upload-files [userId]="currentUser?.id"></app-upload-files>
                            <ion-button color="danger" (click)="deleteUser(currentUser)">Elimina Utente</ion-button>
                        </div>


                        <div class="flex-panel" *ngIf="currentPanel == 'clienti'">
                            <app-clients-list [owner]="currentUser"></app-clients-list>
                        </div>

                        <div class="flex-panel" *ngIf="currentPanel == 'contratti'">
                            <app-client-contracts
                                    [owner]="currentUser"
                            ></app-client-contracts>
                        </div>

                        <div
                                class="flex-panel"
                                *ngIf="currentPanel == 'bonuses'"
                                style="padding-bottom: 100px"
                        >
                            <app-user-bonuses [owner]="currentUser"></app-user-bonuses>
                        </div>

                        <!-- ...a qui -->
                    </div>

                </div>
            </div>
        </ion-content>
    </div>
</div>

